export default {
  saveLog: 'Save',
} as const;
